import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { mainApiSlice } from "./features/api/mainApiSlice";
import authReducer from "./features/auth/authSlice";
import settingsReducer from "./features/settings/settingsSlice";
import faqReducer from "./features/faq/faqSlice";
import usersManagementReducer from "./features/usersManagement/usersManagementSlice";
import languageReducer from "./features/language/languageSlice";
import ticketsReducer from "./features/tickets/ticketsSlice";
import solutionsReducer from "./features/solutions/solutionsSlice";
import creditsReducer from "./features/credits/creditsSlice";
import projectReducer from "./features/projects/projectsSlice";
import orderReducer from "./features/orders/orderSlice";

export const store = configureStore({
  reducer: {
    language: languageReducer,
    usersManagement: usersManagementReducer,
    tickets: ticketsReducer,
    solutions: solutionsReducer,
    credits: creditsReducer,
    auth: authReducer,
    settings: settingsReducer,
    project: projectReducer,
    order: orderReducer,
    faq: faqReducer,

    [mainApiSlice.reducerPath]: mainApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(mainApiSlice.middleware),
});

setupListeners(store.dispatch);
